import React from 'react';
import { AppSkeletonImage } from '../../common/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/classic-report-app-skeleton.tpl.svg';

export const ClassicReportSkeleton = () => <AppSkeletonImage src={imgSVG} />;
